import React from "react"
import ContactForm from "../../components/noone/ContactForm"
import ContactOther from "../../components/noone/ContactOther"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/noone/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const contact = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.contact} siteTitle="noone" />
      <HeadingL title={PAGE.title.contact} target="noone" />
      <ContactForm />
      <ContactOther />
    </Layout>
  )
}

export default contact
